/**
 * Vehicle power plant type values
 */
export enum VehiclePowerPlantTypeEnum {
	UNLEADED = 'unleaded',
	DIESEL = 'diesel',
	HYDROGEN = 'hydrogen',
	ELECTRIC = 'electric',
	ETHANOL = 'ethanol',
	NEAT_ETHANOL = 'neat_ethanol',
	METHANOL = 'methanol',
	NEAT_METHANOL = 'neat_methanol',
	CNG = 'cng',
	LNG = 'lng',
	LPG = 'lpg',
	NATURAL_GAS = 'natural_gas',
}
